<div class="bulk-delete-dialog">
  <div class="bulk-delete-header">
    <mat-icon class="bulk-delete-icon">delete_outline</mat-icon>
    <h3 class="bulk-delete-title">{{ 'Delete confirmation' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="bulk-delete-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="bulk-delete-content">
    <p class="bulk-delete-desc">
      {{ 'Are you sure you want to delete' | translate }} {{ itemCount }} {{ entityLabelKey | translate }}?
    </p>
    @if (data.subtitle) {
      <p class="bulk-delete-subtitle">{{ data.subtitle }}</p>
    }
    <p class="bulk-delete-warning">{{ 'This action cannot be undone.' | translate }}</p>
    @if (data.warningNote) {
      <p class="bulk-delete-warning">{{ data.warningNote }}</p>
    }

    <div class="bulk-delete-items-section">
      <p class="bulk-delete-items-label">{{ (data.itemsLabel ?? 'THE FOLLOWING ITEMS WILL BE PERMANENTLY DELETED:') | translate }}</p>
      <div class="bulk-delete-items-list">
        @for (item of data.items; track trackByIndex(i); let i = $index) {
          <div class="bulk-delete-item-row">
            <mat-icon class="bulk-delete-item-icon">description</mat-icon>
            <div class="bulk-delete-item-details">
              <span class="bulk-delete-item-name">{{ item[data.displayProperty] }}</span>
              @if (itemDescriptions[i]) {
                <span class="bulk-delete-item-description">
                  ({{ itemDescriptions[i] }})
                </span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="bulk-delete-actions">
    <button class="bulk-delete-btn confirm" (click)="onDelete()">
      {{ 'Delete' | translate }} {{ itemCount }} {{ entityLabelKey | translate }}
    </button>
    <button class="bulk-delete-btn cancel" (click)="onCancel()">
      {{ 'Cancel' | translate }}
    </button>
  </div>
</div>
